/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_ChangesInputs */

const en_publish_changes = /** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Changes`)
};

const id_publish_changes = /** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan Perubahan`)
};

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const es_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const fr_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const de_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const ja_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const zh_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const ar_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const it_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const ru_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const pt_publish_changes = en_publish_changes;

/** @type {(inputs: Publish_ChangesInputs) => LocalizedString} */
const ko_publish_changes = en_publish_changes;

/**
* | output |
* | --- |
* | "Publish Changes" |
*
* @param {Publish_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const publish_changes = /** @type {((inputs?: Publish_ChangesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_ChangesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publish_changes(inputs)
	if (locale === "es") return es_publish_changes(inputs)
	if (locale === "fr") return fr_publish_changes(inputs)
	if (locale === "de") return de_publish_changes(inputs)
	if (locale === "ja") return ja_publish_changes(inputs)
	if (locale === "zh") return zh_publish_changes(inputs)
	if (locale === "ar") return ar_publish_changes(inputs)
	if (locale === "id") return id_publish_changes(inputs)
	if (locale === "it") return it_publish_changes(inputs)
	if (locale === "ru") return ru_publish_changes(inputs)
	if (locale === "pt") return pt_publish_changes(inputs)
	return ko_publish_changes(inputs)
});